<template>
  <v-container class="py-0 px-0 w-100">
    <v-list-item class="p-0 w-100">
      <v-card @click="navigateTo(notification)" class="py-4 px-4 hover-item w-100">
        <v-row no-gutters>
          <v-col cols="11">
            <v-row class="pb-1 pl-3" v-if="notificationDetails">
              <v-icon class="pr-2" :color="notificationDetails.color" size="20">
                {{ notificationDetails.icon }}
              </v-icon>
              <span class="font-weight-bold pr-2">{{ notification.title }}</span>
              <span>{{ creationDate }}</span>
            </v-row>
            <v-row>
              <span class="pl-3">{{ sanitizedMessage }}</span>
            </v-row>
          </v-col>
          <v-col cols="1" class="read-status">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click.stop="() => updateNotificationStatus('readStatus')"
                  color="#70c1b3"
                  >{{ readIcon }}
                </v-icon>
              </template>
              {{ readStatus }}
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card>
    </v-list-item>
  </v-container>
</template>
<script>
import getCurrentUserX from "@/mixins/getCurrentUserX";
import moment from "moment"

export default {
  name: "NotificationItemsDropdown",
  mixins: [getCurrentUserX],
  props: {
    notification: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      isRead: !this.notification.is_read ? false : true,
      readIcon: !this.notification.is_read ? "mdi-circle" : "mdi-circle-half-full",
    };
  },
  computed: {
    notificationDetails() {
      const notificationMapping = {
        tasks: {
          text: "Task",
          icon: "mdi-calendar-check",
          color: "#70c1b3",
        },
        communications: {
          text: "Communication",
          icon: "mdi-message-alert",
          color: "#ffb822",
        },
        information_updates: {
          text: "Information Update",
          icon: "mdi-information",
          color: "primary",
        },
        new_leads: {
          text: "New Lead",
          icon: "mdi-account-plus",
          color: "dark-grey",
        },
        team: {
          text: "Lead Added to Team",
          icon: "mdi-account-group",
          color: "var(--primary-color)",
        },
        housejet_plan: {
          text: "HOUSEJET",
          icon: "mdi-bell-ring",
          color: "#9c27b0",
        },
      };

      return notificationMapping[this.notification.type];
    },
    sanitizedMessage() {
      if (!this.notification.message) return '';
      return this.notification.message
        // Handle escaped quotes (convert \' to ' etc)
        .replace(/\\['"`]/g, match => match.charAt(1))
    },
    creationDate() {
      const created = moment(this.notification.created);
      const now = moment();

      return created.fromNow();
    },
    dueDate() {
      if (this.notification.date) {
        if (
          moment().format("MM/DD/YYYY") ===
          moment(this.notification.date).format("MM/DD/YYYY")
        ) {
          return "Today " + moment.parseZone(this.notification.date).format("h:MM A");
        } else {
          return moment.parseZone(this.notification.date).format("MM/DD/YYYY h:MM A");
        }
      }

      return 'Unknown'
    },
    readStatus() {
      return !this.isRead ? "Mark as Read" : "Mark as Unread";
    },
  },
  mounted() {
    this.getCurrentUser();
  },
  methods: {
    async updateNotificationStatus(action) {
      this.loading = true;
      try {
        const data = {
          notification: this.notification.id,
          action: action,
        };

        let response = await this.$http.put(
          "/api/v1/notificationMessages/updateNotificationStatus",
          data
        );

        if (action === "archive") {
          this.isArchived = response.data.notificationMessage.is_archived;
        }

        this.$emit("refresh");

        this.loading = false;
      } catch (error) {
        console.error(`Error updating notification status (${action}): `, error);
        this.loading = false;
      }
    },
    async navigateTo(notification) {
      const name = this.getNotificationName(notification.reference_type)
      const lead_id = notification.lead_id
      await this.updateNotificationStatus("readStatus")
      this.$root.$emit('refreshBadgeCounts')
      this.$router.push({ name: name, query: { id: lead_id } });
    },
    buildRoute(item) {
        const route = { name: item.name };

        if (item.query && typeof item.query === 'object') {
            route.query = { ...item.query };
        }

        return route;
    },
    getNotificationName(reference_type) {
      switch (reference_type) {
        case "lead_added_to_team":
          return "teams";
        case "new_support_ticket":
        case "support_ticket_reply":
          return "support";
        default:
          return "profile";
      }
    }
  },
};
</script>
<style scoped>
.notification-item {
  border-bottom: 1px solid var(--tertiary);
}
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: transparent !important;
}
.hover-item {
  transition: all ease-in-out 300ms;
  border-radius: 0;
  margin-bottom: 1px;
}
.hover-item:hover {
  background-color: var(--info);
}

.mdi-circle,
.mdi-circle-half-full {
  border: solid 1px transparent;
  border-radius: 50px;
  padding: 4px;
  transition: all ease-in-out 300ms;
  height: 20px;
}
.mdi-circle:hover,
.mdi-circle-half-full:hover {
  border: solid 1px #c4c2c2;
  border-radius: 50px;
  padding: 4px;
  height: 20px;
}
.mdi-circle-half-full::before,
.mdi-circle::before {
  font-size: 10px;
}
.notification-dropdown-list-item {
  transition: all ease-in-out 300ms;
}

.notification-dropdown-list-item:hover {
  background-color: var(--tertiary);
}
.read-status {
  display: flex;
  justify-content: flex-end !important;
  align-items: center !important;
}
</style>
